package presentation.screens.history

import features.watch.model.WatchEntry
import utils.UiAction
import utils.UiState

enum class HistoryBucket {
    TODAY,
    YESTERDAY,
    WEEK,
    EARLIER,
}

data class HistoryGroup(
    val bucket: HistoryBucket,
    val items: List<WatchEntry>,
)

data class HistoryState(
    val groups: List<HistoryGroup> = emptyList(),
) : UiState

sealed interface HistoryMVIAction : UiAction {
    data object Back : HistoryMVIAction
    data class Open(val entry: WatchEntry) : HistoryMVIAction
    data class Delete(val entry: WatchEntry) : HistoryMVIAction
}
